import { Button } from '@storeblocks/button';
import { SystemIcon } from '@storeblocks/icon';
import { type FC } from 'react';
import styled from 'styled-components';

import { Show } from '@/components/Show';

import { DebugSurface } from './DebugSurface';
import { useCopyBearerToken } from './useCopyBearerToken';

export const CopyBearerToken: FC = () => {
  const { copyToClipboard, loading, success } = useCopyBearerToken();

  return (
    <DebugSurface>
      <p>Copy the bearer authentication token to your clipboard.</p>
      <Container>
        <Button
          onClick={() => copyToClipboard()}
          loading={loading}
          disabled={loading}
        >
          Copy to clipboard
        </Button>

        <Show when={success}>
          <SystemIcon name="check_circle_filled" isPhosphor />
          <span>Copied!</span>
        </Show>
      </Container>
    </DebugSurface>
  );
};

const Container = styled.div`
  margin-top: 16px;
  display: flex;
  gap: 8px;
  align-items: center;
`;
